"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IssueActivityLogApi = void 0;
var _ActivityLog = require("../types/ActivityLog");
var _endpointHelpers = require("../util/endpointHelpers");
var _urlExtractors = require("../util/urlExtractors");
const IssueActivityLogApi = exports.IssueActivityLogApi = (0, _endpointHelpers.createEndpointSdk)(_ref => {
  let {
    api
  } = _ref;
  return {
    getAll: function (id) {
      let {
        limit,
        offset
      } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      let customFilters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        placementActivities: false,
        deletedIssueActivity: false,
        restoredIssueActivity: false,
        snapshotIssueActivity: false,
        attachmentIssueActivity: false
      };
      const url = "issues/".concat(id, "/activities");
      const searchParams = new URLSearchParams();
      let verbs;
      if (customFilters.placementActivities) {
        verbs = Object.values(_ActivityLog.activityVerbs);
      } else {
        const {
          ISSUE_PLACEMENT_ADD,
          ISSUE_PLACEMENT_REPOSITION,
          ISSUE_PLACEMENT_REMOVE,
          ...restVerbs
        } = _ActivityLog.activityVerbs;
        verbs = Object.values(restVerbs);
      }
      if (!customFilters.deletedIssueActivity) {
        verbs = verbs.filter(x => x !== _ActivityLog.activityVerbs.ISSUE_DELETED);
      }
      if (!customFilters.restoredIssueActivity) {
        verbs = verbs.filter(x => x !== _ActivityLog.activityVerbs.ISSUE_RESTORED);
      }
      if (!customFilters.snapshotIssueActivity) {
        verbs = verbs.filter(x => x !== _ActivityLog.activityVerbs.ISSUE_SNAPSHOT_EDIT);
      }
      if (!customFilters.attachmentIssueActivity) {
        verbs = verbs.filter(x => x !== _ActivityLog.activityVerbs.ISSUE_ATTACHMENT_ADD && x !== _ActivityLog.activityVerbs.ISSUE_ATTACHMENT_REMOVE);
      }
      searchParams.set("filter[verb]", Object.values(verbs).join(","));
      if (limit) {
        searchParams.set("limit", limit.toString());
      }
      if (offset) {
        searchParams.set("offset", offset.toString());
      }
      const search = searchParams.toString();
      return api.getAll(search ? "".concat(url, "?").concat(search) : url).then(result => ({
        pagination: result.pagination,
        results: result.results.map(result => {
          return serverActivityToActivityBlock(result, customFilters.placementActivities);
        })
      }));
    }
  };
}, {
  // invalidated also by Issues api
  invalidateByQueryKeys: url => [["issues", (0, _urlExtractors.extractIssueId)(url), "activities"]]
});
function serverActivityToActivityBlock(serverActivity, include3dPlacementActivity) {
  const {
    verb,
    actor,
    object,
    published
  } = serverActivity.activity;
  const activityChanges = [];
  if (verb === _ActivityLog.activityVerbs.ISSUE_DELETED) {
    activityChanges.push({
      changeType: _ActivityLog.activityChangeType.IssueDeleted,
      before: null,
      after: null,
      verb,
      object
    });
  }
  if (verb === _ActivityLog.activityVerbs.ISSUE_RESTORED) {
    activityChanges.push({
      changeType: _ActivityLog.activityChangeType.IssueRestored,
      before: null,
      after: null,
      verb,
      object
    });
  }
  _ActivityLog.activityChangeTypes.forEach(changeType => {
    if ([_ActivityLog.activityVerbs.ISSUE_DELETED, _ActivityLog.activityVerbs.ISSUE_RESTORED].includes(verb)) {
      return;
    }
    if (object[changeType]) {
      if (!include3dPlacementActivity && changeType === _ActivityLog.activityChangeType.ChangedLinkedDocument) {
        return;
      }
      activityChanges.push({
        changeType,
        before: object[changeType].before,
        after: object[changeType].after,
        verb,
        object
      });
    }
  });
  return {
    verb,
    actor,
    changes: activityChanges,
    date: new Date(published)
  };
}
//# sourceMappingURL=IssueActivityLogApi.js.map